import { createContext, useContext } from "react"
import type { ElementRegistry } from "./element-registry"
import type { CogoBlockDef } from "./types"
import type { DesignTokens } from "../runtime/design-tokens"

export interface RenderContextValue {
  registry: ElementRegistry
  resolveSymbol: (expr: string) => unknown
  dispatchEvent: (elementId: string, eventType: string, payload?: unknown) => void
  mode: "preview" | "edit"
  blocks?: Record<string, CogoBlockDef>
  itemContext?: Record<string, unknown>
  designTokens?: DesignTokens
}

export const RenderContext = createContext<RenderContextValue | null>(null)

export function useRenderContext(): RenderContextValue {
  const ctx = useContext(RenderContext)
  if (!ctx) throw new Error("RenderContext.Provider is missing")
  return ctx
}
